export const GetReferralList = ({ pageSize = 10, pageNumber = 1 }) =>
  `Referral/GetReferralList?PageSize=${pageSize}&PageNumber=${pageNumber}`;

export const GetReferralDefault = "Referral/GetReferralDefault";

export const ReferralNew = "Referral/ReferralNew";

export const ReferralCodeAfterRegister = "Referral/ReferralCodeAfterRegister";

export const GetReferralIsNotPaid = "Referral/GetReferralIsNotPaid";

// referral history
export const GetReferralIsPaidList = ({ pageSize = 10, pageNumber = 1 }) =>
  `Referral/GetReferralIsPaidList?PageSize=${pageSize}&PageNumber=${pageNumber}`;
